import { render, staticRenderFns } from "./item.vue?vue&type=template&id=385290f6&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385290f6')) {
      api.createRecord('385290f6', component.options)
    } else {
      api.reload('385290f6', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=385290f6&", function () {
      api.rerender('385290f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutComponents/Menu/MenuTop/partials/item.vue"
export default component.exports